import CurriculumManager from './CurriculumManager';

export default function CurriculumPage() {
  return <CurriculumManager />;
}
